<div class="course-form">

  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-users" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">{{batchTitle}}</h1>
      <p class="cf-head__sub">Batch dates and assessment schedule</p>
    </div>
    <div class="cf-head__actions" *ngIf="showSave">
      <button type="submit" class="btn m-0" (click)="SaveBatch()">
        <i class="fas fa-save" aria-hidden="true"></i> Save Batch
      </button>
    </div>
  </header>

  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-calendar-alt" aria-hidden="true"></i> Batch Details</h2>
    <div class="cf-grid">
      <div class="fieldset fieldset--lg">
        <label for="name" class="legend">Name <span class="requiredfield">*</span></label>
        <input class="text-field" required type="text" id="name" name="name" [(ngModel)]="moduleBatch.name"
          [ngModelOptions]="{standalone: true}" [disabled]="!showSave">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Batch name"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">What this group of students is called. It has to be different from the other batches on this course.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label for="batchStartDate" class="legend">Start Date <span class="requiredfield">*</span></label>
        <input [owlDateTime]="rawStartTime" class="text-field" id="batchStartDate" name="batchStartDate"
          [ngModelOptions]="{standalone: true}" [disabled]="!showSave" [(ngModel)]="moduleBatch.startDate">
        <button [owlDateTimeTrigger]="rawStartTime" type="button"
          class="owlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
          title="Calendar" [disabled]="!showSave"><i class="fa fa-calendar"></i></button>
        <owl-date-time #rawStartTime></owl-date-time>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Start date"
          class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">When the batch begins. Each assessment on the course takes its start date from this one.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label for="batchEndDate" class="legend">End Date <span class="requiredfield">*</span></label>
        <input [owlDateTime]="rawEndTime" class="text-field" id="batchEndDate" name="batchEndDate"
          [ngModelOptions]="{standalone: true}" [disabled]="!showSave" [(ngModel)]="moduleBatch.endDate">
        <button [owlDateTimeTrigger]="rawEndTime" type="button" [disabled]="!showSave"
          class="owlDateTimeTrigger position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
          title="Calendar"><i class="fa fa-calendar"></i></button>
        <owl-date-time #rawEndTime></owl-date-time>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="End date"
          class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">When the batch finishes. Each assessment takes its due date from this one.</p>
        </div>
      </div>
    </div>
    <p class="cf-note">Ending a batch does not remove access — students keep the course for as long as their access days allow.</p>
  </section>

  <section class="cf-card" *ngIf="asssmentDate.length>=0 && isEdit">
    <h2 class="cf-card__title"><i class="far fa-clipboard" aria-hidden="true"></i> Assessment Schedule</h2>
    <div class="table-responsive">
      <table class="table align-items-center table-flush table-hover">
        <thead class="thead-light">
          <tr>
            <th>Name</th>
            <th>Class Title</th>
            <th>Start</th>
            <th>Stop</th>
            <th class="text-center" *ngIf="isAssessmentEditable">Action</th>
          </tr>
        </thead>
        <tbody>
          <!-- Every row's date inputs previously shared id/name "startDate" — including the
               stop field — so the whole table registered under one duplicated control name. -->
          <tr *ngFor="let item of asssmentDate; let i = index">
            <td>{{item.name}}</td>
            <td>{{item.classTitle}}</td>
            <td>
              <div class="fieldset m-0">
                <input [owlDateTime]="rowStart" class="text-field" [id]="'assessStart' + i" [name]="'assessStart' + i"
                  [ngModelOptions]="{standalone: true}" [disabled]="!item.editable" [(ngModel)]="item.startTime">
                <button [owlDateTimeTrigger]="rowStart" type="button"
                  class="owlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
                  title="Calendar" [disabled]="!item.editable"><i class="fa fa-calendar"></i></button>
                <owl-date-time #rowStart></owl-date-time>
              </div>
            </td>
            <td>
              <div class="fieldset m-0">
                <input [owlDateTime]="rowStop" class="text-field" [id]="'assessStop' + i" [name]="'assessStop' + i"
                  [ngModelOptions]="{standalone: true}" [disabled]="!item.editable" [(ngModel)]="item.stopTime">
                <button [owlDateTimeTrigger]="rowStop" type="button"
                  class="owlDateTimeTrigger bottom-0 position-absolute right-0 top-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
                  title="Calendar" [disabled]="!item.editable"><i class="fa fa-calendar"></i></button>
                <owl-date-time #rowStop></owl-date-time>
              </div>
            </td>
            <td class="text-center" *ngIf="isAssessmentEditable">
              <button class="btn m-0" *ngIf="!item.editable" (click)="onRowEditInit(item, i)">Edit</button>
              <button class="btn m-0" *ngIf="item.editable" (click)="submitAssessmentBatch(item)">Update</button>
            </td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="asssmentDate.length<=0" class="cf-empty">No assessments scheduled</p>
    </div>
  </section>
</div>

  <!-- <div class="modal fade" id="updateAssessmentDate" data-keyboard="false" data-backdrop="static" aria-hidden="true"
    role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-0">
          <div class="text-uppercase">
            <h3 class="modal-title text-center mb-2">Assessment Date Update for {{assessmentDateUpdate.name}}</h3>
            <div class="row row-cols-2 mb-3">
              <div class="col">
                <label class="sbw_light">Start Time:</label>
                <input class="form-control" type="datetime-local" [(ngModel)]="assessmentDateUpdate.startTime"
                  [ngModelOptions]="{standalone: true}">
              </div>
              <div class="col">
                <label class="sbw_light">Stop Time:</label>
                <input class="form-control" type="datetime-local" [(ngModel)]="assessmentDateUpdate.stopTime"
                  [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="d-flex justify-content-center flex-wrap gap-1.5">
              <button type="button" class="btn m-0 bg-danger" data-dismiss="modal"
                (click)="submitAssessmentBatch()">Submit</button>
              <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
